import {action, computed, observable, makeObservable} from 'mobx';
import {enumToValues} from '@netx/core-next/utils/enum';
import {fileTypes} from '@netx/core-search/properties/search';
import {RuleModel} from '../baseModel';
import {
	FileFormatType,
	SearchTypeFileFormat,
	TSearchTypeFileFormat,
} from './constants';
import {fileFormatRuleDefaults} from './defaults';
import type {FileFormatRule} from './types';
import {validateFileFormatRule} from './validate';

export class FileFormatRuleModel
	extends RuleModel<TSearchTypeFileFormat>
	implements FileFormatRule
{
	readonly elementType = SearchTypeFileFormat;
	elementSubType1: FileFormatType = fileFormatRuleDefaults.elementSubType1;
	elementSubType2: 0 = fileFormatRuleDefaults.elementSubType2;
	elementValue1 = fileFormatRuleDefaults.elementValue1;
	elementValue2: '' = fileFormatRuleDefaults.elementValue2;
	elementValue3: '' = fileFormatRuleDefaults.elementValue3;

	get elementSubType1Options() {
		return enumToValues(FileFormatType);
	}

	get isValid() {
		const validation = validateFileFormatRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<FileFormatRule, 'elementType'>>) {
		super();

		Object.assign(this, {
			...fileFormatRuleDefaults,
			elementValue1: Object.keys(fileTypes)[0],
			...params,
		});

		makeObservable(this, {
			isValid: computed,
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementValue1: observable,
			setElementSubType1: action,
			setElementValue1: action,
		});
	}

	/**
	 * Set match type
	 * @param elementSubType1 FileFormatType
	 */
	setElementSubType1(elementSubType1: FileFormatType) {
		this.elementSubType1 = elementSubType1;
	}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set file format
	 * @param elementValue1 file format
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default FileFormatRuleModel;
